import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type QuickSearchProjectFragment = { __typename?: 'Project', id: string, name: string, insertedAt: string, private: boolean, archivedAt?: string | null };

export const QuickSearchProject = /*#__PURE__*/ gql`
    fragment QuickSearchProject on Project {
  id
  name
  insertedAt
  private
  archivedAt
}
    ` as unknown as DocumentNode<QuickSearchProjectFragment, unknown>;

        

        
export const useQuickSearchProjectFragment = (
  input: string | Omit<UseFragmentOptions<QuickSearchProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<QuickSearchProjectFragment>({
    fragment: QuickSearchProject,
    fragmentName: 'QuickSearchProject',
    ...options,
  });
};
  
        